<template>
  <div
    class="h-fit w-fit items-center rounded py-1 px-4 leading-[0.875rem] disabled:cursor-default"
    :class="[
      variant === 'primary' ? 'bg-primary-50 text-secondary-500 disabled:text-secondary-200' : '',
      variant === 'secondary' ? 'bg-secondary-50 text-secondary-500 disabled:text-neutral-200' : '',
      variant === 'success' ? 'bg-success-50 text-success-500 disabled:text-success-200' : '',
      variant === 'warning' ? 'bg-warning-50 text-warning-500 disabled:text-warning-200' : '',
      variant === 'error' ? 'bg-error-50 text-error-500 disabled:text-error-200' : '',
      variant === 'neutral' ? 'bg-neutral-100 text-neutral-600 disabled:text-neutral-200' : '',
      variant === 'eVactive' ? 'bg-eVactive-50 text-eVactive-500 disabled:text-eVactive-200' : '',
      variant === 'eVavailable' ? 'bg-eVavailable-50 text-eVavailable-500 disabled:text-eVavailable-200' : '',
      variant === 'eVcharging' ? 'bg-eVcharging-50 text-eVcharging-500 disabled:text-eVcharging-200' : '',
      variant === 'eVerror' ? 'bg-eVerror-50 text-eVerror-500 disabled:text-eVerror-200' : '',
      variant === 'eVfullyCharged'
        ? 'bg-eVfullyCharged-50 text-eVfullyCharged-500 disabled:text-eVfullyCharged-200'
        : '',
      variant === 'eVinactive' ? 'bg-eVinactive-50 text-eVinactive-500 disabled:text-eVinactive-200' : '',
      bold ? 'font-bold' : '',
      clickable ? 'cursor-pointer' : '',
      size === 'xs' ? 'px-2 text-[0.4rem]' : '',
      size === 'sm' ? 'px-3 text-[0.525rem]' : '',
      size === 'base' ? 'text-[0.625rem]' : '',
      size === 'md' ? 'text-[0.75rem]' : '',
      size === 'lg' ? 'text-[1rem]' : '',
      inline ? 'inline-flex' : 'flex'
    ]"
    :disabled="disabled"
    @click="onClick()"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import type { UiTagVariant } from '@infuse/ui/domain';

interface Emits {
  (e: 'click'): void;
}

const emit = defineEmits<Emits>();

interface Props {
  variant?: UiTagVariant;
  bold?: boolean;
  clickable?: boolean;
  disabled?: boolean;
  inline?: boolean;
  size?: 'xs' | 'sm' | 'base' | 'md' | 'lg';
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'neutral',
  clickable: false,
  disabled: false,
  inline: false,
  size: 'base'
});

function onClick() {
  if (props.clickable) {
    emit('click');
  }
}
</script>
